import { InitComponent } from "@/components/Reference"

import { ReferenceExtension } from "../Reference"

export const ReferenceLink = ReferenceExtension.extend({
  name: "referenceLink"
}).configure({
  /** URL references only need paste rules, so plain @ text must not activate suggestions. */
  withSuggestion: false,
  pasteRules: "(http|https)://.([^\\s]+)",
  component: InitComponent
})
